import { MenuCodes } from '../../constants';
import { ReactComponent as HomeIcon } from '../../assets/icons/home.svg';
import { ReactComponent as ReportsIcon } from '../../assets/icons/reports.svg';
import { ReactComponent as ActiveIcon } from '../../assets/icons/active.svg';
import { ReactComponent as PaymentMethodsIcon } from '../../assets/icons/payment-methods.svg';
import { ReactComponent as TransactionsIcon } from '../../assets/icons/transactions.svg';
import { ReactComponent as SettlementIcon } from '../../assets/icons/settlement.svg';
import { ReactComponent as PayoutsIcon } from '../../assets/icons/payouts.svg';
import { ReactComponent as PaymentLinkIcon } from '../../assets/icons/payment-link.svg';
import { ReactComponent as PaymentLinkCreateIcon } from '../../assets/icons/payment-link-create.svg';
import { ReactComponent as OneTimePaymentLinkIcon } from '../../assets/icons/payment-link-one-time.svg';
import { ReactComponent as RecurringPaymentLinkIcon } from '../../assets/icons/payment-link-recurring.svg';
import { ReactComponent as OpenPaymentLinkMenuIcon } from '../../assets/icons/payment-link-open.svg';
import { ReactComponent as QRPaymentMenuIcon } from '../../assets/icons/qr-payment.svg';
import { ReactComponent as SmartPaymentIcon } from '../../assets/icons/smart-payment.svg';
import { ReactComponent as SubscriptionsCalendarIcon } from '../../assets/icons/subscriptions-calendar.svg';
import { ReactComponent as PaymentButtonDollarIcon } from '../../assets/icons/payment-button-dollar.svg';
import { ReactComponent as VirtualPOSIcon } from '../../assets/icons/virtual-pos.svg';
import { ReactComponent as PaymentIntegrationIcon } from '../../assets/icons/payment-integration.svg';
import { ReactComponent as CompanyInfoIcon } from '../../assets/icons/company-info.svg';
import { ReactComponent as RefundsIcon } from '../../assets/icons/refunds.svg';
import { ReactComponent as ClientsIcon } from '../../assets/icons/clients.svg';
import { ReactComponent as BankAccountsIcon } from '../../assets/icons/bank-accounts.svg';
import { ReactComponent as SubItemIcon } from '../../assets/icons/sub-item.svg';
import { ReactComponent as AffiliationsIcon } from '../../assets/icons/user-transfer.svg';
import { ReactComponent as SplitIcon } from '../../assets/icons/split-icon.svg';
import { ReactComponent as SidebarPagarIcon } from '../../assets/icons/sidebar-pagar.svg';
import { ReactComponent as SidebarConexionesIcon } from '../../assets/icons/sidebar-conexiones.svg';
import { ReactComponent as MarketingIcon } from '../../assets/icons/marketing.svg';
import { ReactComponent as UserManagementIcon } from '../../assets/icons/user-management.svg';
import { Bitcoin, Calculator, ChartLine, ChartNoAxesColumn, ChartPie, CircleDollarSign, CircleUser, Clock, MapPin, Pipette, RefreshCcw, Settings, ShieldCheck, User } from 'lucide-react';
import { ReactComponent as ApiCloudIcon } from '../../assets/icons/api-cloud.svg';

/** Trazo fino alineado a SVGs rellenos del menú (p. ej. Métodos de pago) */
const MENU_LUCIDE_STROKE_SUBTLE = 1.35;

export const icons = (key: string) => {
  switch (key) {
    case MenuCodes.HOME:
      return <HomeIcon />;
    case MenuCodes.REPORTS:
      return <ReportsIcon />;
    case MenuCodes.ACTIVATE_ACCOUNT:
      return <ActiveIcon />;
    case MenuCodes.TRANSACTIONS:
      return <TransactionsIcon />;
    case MenuCodes.PAYMENT_METHODS:
      return <PaymentMethodsIcon />;
    case MenuCodes.SPLIT_PAYMENTS:
      return <SplitIcon />;
    case MenuCodes.MARKETING:
      return <MarketingIcon />;
    case MenuCodes.SETTLEMENTS:
      return <SettlementIcon />;
    case MenuCodes.PAYMENT_LINK:
      return <PaymentLinkIcon />;
    case MenuCodes.CREATED_PAYMENT_LINKS:
      return <PaymentLinkIcon />;
    case MenuCodes.CREATE_ONE_TIME_PAYMENT_LINK:
      return <PaymentLinkCreateIcon />;
    case MenuCodes.ONE_TIME_PAYMENT_LINK:
      return <OneTimePaymentLinkIcon />;
    case MenuCodes.RECURRING_PAYMENT_LINK:
      return <RecurringPaymentLinkIcon />;
    case MenuCodes.OPEN_PAYMENT_LINK:
      return <OpenPaymentLinkMenuIcon />;
    case MenuCodes.QR_PAYMENT:
      return <QRPaymentMenuIcon />;
    case MenuCodes.SMART_PAYMENT:
      return <SmartPaymentIcon />;
    case MenuCodes.VIRTUAL_POS:
      return <VirtualPOSIcon />;
    case MenuCodes.PAYMENT_BUTTON:
      return <PaymentButtonDollarIcon />;
    case MenuCodes.PAYMENT_INTEGRATION:
      return <PaymentIntegrationIcon />;
    case MenuCodes.COMPANY_INFORMATION:
      return <CompanyInfoIcon />;
    case MenuCodes.REFUNDS:
      return <RefundsIcon />;
    case MenuCodes.PAYOUTS:
      return <SidebarPagarIcon />;
    case MenuCodes.PAYOUT_CONTACTS:
      return <User className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.PAY_FUND_TRANSFER:
      return <RefreshCcw className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.PAY_FUND_CRYPTO:
      return <Bitcoin className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.CLIENTS:
      return <ClientsIcon />;
    case MenuCodes.BANK_ACCOUNTS:
      return <BankAccountsIcon />;
    case MenuCodes.CHARGEBACKS:
      return <VirtualPOSIcon />;
    case MenuCodes.SUBSCRIPTIONS:
      return <SubscriptionsCalendarIcon />;
    case MenuCodes.CHECKOUT_THEMES:
      return <Pipette className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.TRANSACTIONS_AFFILIATIONS:
      return <AffiliationsIcon />;
    case MenuCodes.USER_MANAGEMENT:
      return <UserManagementIcon />;
    case MenuCodes.SIDEBAR_COBRAR:
      return <PayoutsIcon />;
    case MenuCodes.SIDEBAR_PAGAR:
      return <SidebarPagarIcon />;
    case MenuCodes.SIDEBAR_MOVIMIENTOS:
      return <ChartNoAxesColumn className="menu-lucide" size={16} strokeWidth={2} aria-hidden />;
    case MenuCodes.SIDEBAR_CONEXIONES:
      return <SidebarConexionesIcon />;
    case MenuCodes.SIDEBAR_RENTABILIDAD:
      return <CircleDollarSign className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.SIDEBAR_MARKETING:
      return <ChartLine className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.SIDEBAR_CONFIGURATION:
      return <Settings className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.SIDEBAR_PROFILE:
      return <CircleUser className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.PAYMENT_INTEGRATION_API:
      return <ApiCloudIcon />;
    case MenuCodes.RENTABILITY_COVERAGE:
      return <MapPin className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.RENTABILITY_CALCULATOR:
      return <Calculator className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.RENTABILITY_ACCREDITATION_TIMES:
      return <Clock className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.RENTABILITY_INSTALLMENTS:
      return <ChartPie className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.RENTABILITY_PAYOUTS:
      return <PayoutsIcon />;
    case MenuCodes.RENTABILITY_THREE_D_SECURE:
      return <ShieldCheck className="menu-lucide" size={16} strokeWidth={MENU_LUCIDE_STROKE_SUBTLE} aria-hidden />;
    case MenuCodes.MARKETING_CAMPAIGNS:
      return <MarketingIcon />;
    default:
      return <SubItemIcon />;
  }
};
